<template>
    <section class="bag-products">

        <div class="section-heading">
            <h1>Our Bags</h1>
            <p>Find the perfect leather bag for every occasion.</p>
        </div>

        <div class="bags-container">

            <!-- Bag 1 -->
            <div class="bag-card">
                <img :src="crossbody" alt="Crossbody Bag">

                <div class="bag-info">
                    <h3>Crossbody</h3>
                    <p>&#8358;22,000</p>
                    <button @click="viewProduct(1)">
                        View Details
                    </button>
                </div>
            </div>

            <!-- Bag 2 -->
            <div class="bag-card">
                <img :src="thegrace" alt="The Grace Bag">

                <div class="bag-info">
                    <h3>The Grace</h3>
                    <p>&#8358;20,000</p>
                    <button @click="viewProduct(2)">
                        View Details
                    </button>
                </div>
            </div>

            <!-- Bag 3 -->
            <div class="bag-card">
                <img :src="theclassic" alt="Classic Bag">

                <div class="bag-info">
                    <h3>Classic Bag</h3>
                    <p>&#8358;30,000</p>
                    <button @click="viewProduct(3)">
                        View Details
                    </button>
                </div>
            </div>

            <!-- Bag 4 -->
            <div class="bag-card">
                <img :src="tote" alt="Tote Bag">

                <div class="bag-info">
                    <h3>Tote Bag</h3>
                    <p>&#8358;11,000</p>
                    <button @click="viewProduct(4)">
                        View Details
                    </button>
                </div>
            </div>

        </div>

        <div class="bags-container">

            <!-- Bag 5 -->
            <div class="bag-card">
                <img :src="drawstring" alt="Drawstring Bag">

                <div class="bag-info">
                    <h3>Drawstring</h3>
                    <p>&#8358;18,000</p>
                    <button @click="viewProduct(5)">
                        View Details
                    </button>
                </div>
            </div>

            <!-- Bag 6 -->
            <div class="bag-card">
                <img :src="charm" alt="Charm Bag">

                <div class="bag-info">
                    <h3>Charm Bag</h3>
                    <p>&#8358;16,000</p>
                    <button @click="viewProduct(6)">
                        View Details
                    </button>
                </div>
            </div>

            <!-- Bag 7 -->
            <div class="bag-card">
                <img :src="croc" alt="Croc Bag">

                <div class="bag-info">
                    <h3>Croc Bag</h3>
                    <p>&#8358;25,000</p>
                    <button @click="viewProduct(7)">
                        View Details
                    </button>
                </div>
            </div>

            <!-- Bag 8 -->
            <div class="bag-card">
                <img :src="office" alt="Office Bag">

                <div class="bag-info">
                    <h3>Office Bag</h3>
                    <p>&#8358;11,000</p>
                    <button @click="viewProduct(8)">
                        View Details
                    </button>
                </div>
            </div>

        </div>

    </section>
</template>


<script>
export default {

    data() {
        return {
            crossbody: require('../assets/thecrossbody.avif'),
            thegrace: require('../assets/thegrace.avif'),
            theclassic: require('../assets/theclassic.avif'),
            tote: require('../assets/thetote.avif'),
            drawstring: require('../assets/thedrawstring.avif'),
            charm: require('../assets/thecharm.avif'),
            croc: require('../assets/thecroc.avif'),
            office: require('../assets/officebag.jpg')
        }
    },

    methods: {
        viewProduct(id) {
            this.$router.push('/product/' + id)
        }
    }

}
</script>


<style scoped>
.bag-products {
  padding: 80px 8%;
  background-color: #ffffff;
}

.section-heading {
  text-align: center;
  margin-bottom: 45px;
}

.section-heading h2 {
  font-size: 36px;
  color: #292929;
  margin-bottom: 10px;
}

.section-heading p {
  color: #4a4541;
}

.bags-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
}

.bag-card {
  background-color: #f5f0e8;
  overflow: hidden;
  transition: 0.3s;
  position: relative;
}
.product-details{
  position: absolute;
  bottom: 20px;
  right: 15px;
  width: 180px;
  background:white;
  border-radius: 8px;
  color: #333;
  padding: 15px;
  z-index: 2;
  box-shadow: 0 4px 12px rgba (0, 0, 0, 0.2);

  box-sizing: border-box;
}


product-details button:first-of-type {
  background-color: #c66a4a;
  color: white;
}

.product-details button:last-of-type {
  background-color: #333;
  color: white;
  margin-left: 5px;
}

.product-details h5 {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
}

.product-details p {
  margin-bottom: 8px;
  font-size: 14px;
}
.product-details button {
  border: none;
  padding: 8px 12px;
  margin-top: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 13px;
  transition: 0.2s ease;
}
.product-details button:hover {
  opacity: 0.85;
  transform: translateY(-1px);
}
.bag-card:hover {
  transform: translateY(-5px);
}

.bag-card img {
  width: 100%;
  height: 280px;
  object-fit: cover;
}

.bag-info {
  padding: 20px;
}

.bag-info h3 {
  color: #292929;
  margin-bottom: 10px;
}

.bag-info p {
  color: #c96f4a;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}

.bag-info button {
  background-color: #c96f4a;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  transition: 0.3s;
}

.bag-info button:hover {
  background-color: #292929;
}

@media (max-width: 768px) {

  .bags-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .bag-card img {
    height: 220px;
  }

  .bag-info {
    padding: 15px;
  }

}

@media (max-width: 480px) {

  .bags-container {
    grid-template-columns: 1fr;
  }

  .bag-card img {
    height: 260px;
  }

}
</style>